import { createTransform } from "redux-persist";

// Transform para eliminar todas las claves excepto `tknAuth`
const persistFilter = createTransform(
    // transform state being rehydrated
    (inboundState, key) => {
        if (key !== 'tknAuth') {
            return undefined; // Purgar el resto de las claves
        }
        return inboundState; // Mantener `tknAuth`
    },
    // transform state being persisted
    (outboundState, key) => {
        return outboundState; // No hacer nada al guardar
    },
    // Configura las claves
    { whitelist: ['tknAuth'] }
);

export default persistFilter